enum EScoreType {
  Manual = 0,
  Auto = 1,
  Inherited = 2,
  InheritedAuto = 3,
}

export default EScoreType;
